// copy all static assets under ./ to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `getAssetPath` JavaScript helper below.

const assets = require.context('./', true);
const getAssetPath = (name) => assets(name, true);

export default getAssetPath;
